import styled from '@emotion/styled'
import tw from 'twin.macro'

export const ProductImageWrapper = styled('div')`
  ${tw`relative flex-none w-full sm:w-auto`}

  img {
    ${tw`w-full h-auto mx-auto sm:w-auto`}
  }
`

export const ImageBadges = styled('div')`
  ${tw`absolute w-full p-4 top-0 flex justify-end`}
`
